<script>
export default {
  data() {
    return {
      itemChanged: {
        title: '',
        minimum: 1,
        limit: 99999,
        customDiscount: {
          type: 'fixed',
          value: 0,
          overWrite: false,
        },
      },
    };
  },
  props: {
    item: {
      type: Object,
    },
  },
  methods: {
    changeToggleForProduct(field, value) {
      this.itemChanged.customDiscount = {
        ...this.itemChanged.customDiscount,
        [field]: value,
      };
    },
  },
  mounted() {
    if (this.item) {
      this.itemChanged = {
        ...this.item,
        customDiscount: this.item.customDiscount || {
          type: 'fixed',
          value: 0,
          overWrite: false,
        },
        minimum: this.item.minimum || 1,
        limit: this.item.limit || 99999,
      };
    }
  },
  watch: {
    itemChanged(newValue) {
      this.$emit('update:item', newValue);
    },
  },
};
</script>

<template>
  <div>
    <div class="column" >
      <h4>{{ itemChanged.title }}</h4>
      <div class="row" >
        Value:
        <a-switch
          checked-children="%"
          un-checked-children="$"
          :checked="itemChanged.customDiscount.type === 'percentage'"
          @change="changeToggleForProduct(
            'type',
            itemChanged.customDiscount.type === 'percentage' ? 'fixed' : 'percentage')"
        />
        {{ itemChanged.customDiscount.type === "percentage" ? '%' : '$' }}
        <a-input
          style="width: 100px"
          v-model:value="itemChanged.customDiscount.value"
        />
      </div>
      <div  >
        Overwrite
        <a-switch
          :checked="itemChanged.customDiscount.overWrite"
          @change="changeToggleForProduct(
            'overWrite',
            !itemChanged.customDiscount.overWrite)"
        />
      </div>
    </div>
    <div class="column" >
      <h4>Quantity to apply:</h4>
      <div class="row" >
        <div>Min:</div>
        <a-input-number
          placeholder="Min"
          style="width: 75px"
          v-model:value="itemChanged.minimum"
        />
        <div>Max:</div>
        <a-input-number
          placeholder="Max"
          style="width: 75px"
          v-model:value="itemChanged.limit"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
}

.mini-row {
  width: 250px;
}

.gray {
  border-radius: 5px;
  background-color: #98A6B0;
  padding: 5px;
}

.column {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
</style>
